import revive_payload_client_4sVQNw7RlN from "/var/www/canceller/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/canceller/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/canceller/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/canceller/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/canceller/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/canceller/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/canceller/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/var/www/canceller/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/canceller/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import gtag_client_R70iZRv6jK from "/var/www/canceller/plugins/gtag.client.js";
import notifications_EFFJUsRga8 from "/var/www/canceller/plugins/notifications.js";
import vue_directives_BGxpMNSCZV from "/var/www/canceller/plugins/vue-directives.js";
import wagmi_client_x22JPHDxTO from "/var/www/canceller/plugins/wagmi.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  gtag_client_R70iZRv6jK,
  notifications_EFFJUsRga8,
  vue_directives_BGxpMNSCZV,
  wagmi_client_x22JPHDxTO
]